export const SIDEBAR_ID = 'sidebar';
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@11.0.60 (de4647366)
